var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-10" }, [
    _c(
      "div",
      { staticClass: "p-20 bg-white" },
      [
        _c(
          "el-row",
          { staticClass: "fs-s4" },
          [
            _c(
              "el-col",
              { attrs: { xs: { span: 24 }, sm: { span: 8 } } },
              [
                _c("h4", { staticClass: "mt-0" }, [_vm._v("基础信息")]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-10" }, [
                  _vm._v("商户名称：" + _vm._s(_vm.info.store_info.name)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-10" }, [
                  _vm._v("商户地址：" + _vm._s(_vm.info.store_info.address)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-10" }, [
                  _vm._v(
                    "商户链接：pages/packageB/store/detail?shop_id=" +
                      _vm._s(_vm.info.store_id)
                  ),
                ]),
                _vm._v(" "),
                _vm.info.store_info.use_electricity
                  ? _c("div", [
                      _vm._v(
                        "总用电量：" +
                          _vm._s(_vm.info.store_info.use_electricity)
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selType[0]
                  ? [
                      _c("h4", [_vm._v("充电宝设备资费")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-10" }, [
                        _vm._v(
                          "计费单价：" +
                            _vm._s(_vm.info.bao_fee_plan.rent_fee_std) +
                            "元"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-10" }, [
                        _vm._v(
                          "计费单位：" +
                            _vm._s(_vm.info.bao_fee_plan.rent_unit_minute_std) +
                            "分钟"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "封顶值：" +
                            _vm._s(_vm.info.bao_fee_plan.day_most_std) +
                            "元"
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { xs: { span: 24 }, sm: { span: 8 } } },
              [
                _c("h4", { staticClass: "mt-0" }, [_vm._v("分润信息")]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-10" }, [
                  _vm._v("联系人：" + _vm._s(_vm.info.profit_info.contact)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-10" }, [
                  _vm._v("联系电话：" + _vm._s(_vm.info.profit_info.phone)),
                ]),
                _vm._v(" "),
                _vm._l(_vm.selType, function (item, key) {
                  return _c("div", { key: key, staticClass: "mb-10" }, [
                    _vm._v(
                      _vm._s(_vm.deviceKeyObj[key]) +
                        "分润：" +
                        _vm._s(_vm.showPercent(_vm.info.profit_info, item))
                    ),
                  ])
                }),
                _vm._v(" "),
                _c("div", { staticClass: "mb-10" }, [
                  _vm._v(
                    "提现费率：" +
                      _vm._s(_vm.info.profit_info.withdraw_percent) +
                      "%"
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-10" }, [
                  _vm._v(
                    "提现单笔手续费：" +
                      _vm._s(_vm.info.profit_info.withdraw_fee) +
                      "元"
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "查看订单权限：" +
                      _vm._s(
                        _vm.info.profit_info.check_order == 1 ? "是" : "否"
                      )
                  ),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { xs: { span: 24 }, sm: { span: 8 } } },
              [
                _c("h4", { staticClass: "mt-0" }, [_vm._v("商户收益")]),
                _vm._v(" "),
                _vm.isSyqkObjStatus == 0
                  ? _c("div", [_vm._v(" 数据加载中... ")])
                  : _vm.isSyqkObjStatus == -1
                  ? _c("div", [_vm._v(" 数据加载失败 ")])
                  : _vm.isSyqkObjStatus == 1
                  ? _c("div", [_vm._v(" 暂无数据信息 ")])
                  : [
                      _c("div", { staticClass: "mb-0" }, [
                        _vm._v(
                          "商户收益：￥" +
                            _vm._s(_vm.isSyqkObj.shop_profit) +
                            "元"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-10" }, [
                        _c("span", { staticClass: "gd-width" }, [
                          _vm._v(
                            "可提金额：￥" +
                              _vm._s(_vm.isSyqkObj.profit_money) +
                              "元"
                          ),
                        ]),
                        _vm._v(
                          "---已提金额：￥" +
                            _vm._s(_vm.isSyqkObj.withdrawn_money) +
                            "元"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-10" }, [
                        _c("span", { staticClass: "gd-width" }, [
                          _vm._v(
                            "交易金额：￥" +
                              _vm._s(_vm.isSyqkObj.order_amount) +
                              "元"
                          ),
                        ]),
                        _vm._v(
                          "---交易单数：" +
                            _vm._s(_vm.isSyqkObj.order_num) +
                            "单"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-10" }, [
                        _c("span", { staticClass: "gd-width" }, [
                          _vm._v(
                            "充值金额：￥" +
                              _vm._s(_vm.isSyqkObj.total_pay_money) +
                              "元"
                          ),
                        ]),
                        _vm._v(
                          "---赠送金额：￥" +
                            _vm._s(_vm.isSyqkObj.total_send_money) +
                            "元"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-10" }, [
                        _c("span", { staticClass: "gd-width" }, [
                          _vm._v(
                            "平台增值：￥" +
                              _vm._s(_vm.isSyqkObj.pt_steal_fc) +
                              "元"
                          ),
                        ]),
                        _vm._v(
                          "---平台补贴：￥" +
                            _vm._s(_vm.isSyqkObj.wait_deposit_sharing_income) +
                            "元"
                        ),
                      ]),
                    ],
              ],
              2
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              {
                staticClass: "pr-20",
                attrs: { xs: { span: 24 }, sm: { span: 12 } },
              },
              [
                _c("h4", [_vm._v("商户归属")]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.info.belong,
                      stripe: "",
                      "highlight-current-row": "",
                      border: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "角色" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.role_name) +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "姓名" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.name || "--") +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _vm.checkRoles(["terminal", "partner"])
                      ? _c("el-table-column", {
                          attrs: { label: "手机号码" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.phone || "--") +
                                        "\n            "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            619569281
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", { staticClass: "mt-0" }, [_vm._v("客服跟进记录")]),
                _vm._v(" "),
                _c(
                  "el-row",
                  { staticClass: "mb-10", attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { type: "primary", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.handleViewCustomerDetail()
                              },
                            },
                          },
                          [_vm._v("\n              前往查看\n            ")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { type: "success", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCreateCustomerRecord()
                              },
                            },
                          },
                          [_vm._v("\n              创建记录\n            ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              {
                staticClass: "pr-20",
                attrs: { xs: { span: 24 }, sm: { span: 12 } },
              },
              [
                _c(
                  "h4",
                  [
                    _vm._v("设备信息 "),
                    _vm.selSnArr.length > 0
                      ? _c(
                          "el-link",
                          {
                            staticClass: "pl-15",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteEquip()
                              },
                            },
                          },
                          [_vm._v("解绑设备")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-link",
                      {
                        staticClass: "pl-15",
                        attrs: { type: "primary" },
                        on: { click: _vm.toggleDeviceTable },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.showAllDevices ? "收起" : "展开") +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.info.device_info,
                      stripe: "",
                      "highlight-current-row": "",
                      border: "",
                    },
                    on: { "selection-change": _vm.selSb },
                  },
                  [
                    _c("div", { attrs: { slot: "empty" }, slot: "empty" }, [
                      _c("div", [_vm._v("暂无设备信息")]),
                    ]),
                    _vm._v(" "),
                    _vm.showAllDevices
                      ? [
                          _c("el-table-column", {
                            attrs: { type: "selection", width: "50" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "设备SN码" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(scope.row.goods_sn) +
                                          "\n              "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2250094415
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "铺货日期" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            scope.row.distribute_time || "--"
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3154634272
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-primary",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteEquip(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("解绑")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2760458287
                            ),
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }